import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmployeeNoteService, IEmployeeNote, IEmployeeNotesChangedArgs } from '@shared/services/employee-note.service';
import { Subject, takeUntil } from 'rxjs';
import { EditEmployeeNotesComponent, IEmployeeNotesEditView } from './edit/edit-employee-notes.component';

@Component({
	selector: 'app-employee-note',
	templateUrl: './employee-note.component.html',
	styleUrls: ['./employee-note.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class EmployeeNoteComponent implements OnInit {
	@Input() employeeId: string;
	@Input() date: Date;
	@ViewChild('popup') popup: ElementRef<HTMLDivElement>;

	private internalDate: Date;
	private destroy$: Subject<void> = new Subject<void>();

	notes: IEmployeeNote[];

	constructor(
		private employeeNoteService: EmployeeNoteService,
		public dialog: MatDialog,
	) {}

	get hasNotes(): boolean {
		return this.notes && this.notes.length > 0;
	}

	ngOnInit(): void {
		this.internalDate = new Date(this.date);
		this.getNotes();
		this.employeeNoteService.notesChanged.subscribe({
			next: (c: IEmployeeNotesChangedArgs) => {
				if (c.employeeId === this.employeeId && c.date.getDate() === this.internalDate.getDate()) {
					this.getNotes();
				}
			},
		});
	}

	getNotes() {
		this.employeeNoteService.getNotesByEmployeeAndDate(this.employeeId, this.internalDate).subscribe((c) => (this.notes = c));
	}

	onEdit($event: MouseEvent): void {
		$event.stopPropagation();

		const data: IEmployeeNotesEditView = {
			employeeId: this.employeeId,
			date: this.date,
			notes: this.notes,
		};

		const dialogRef = this.dialog.open(EditEmployeeNotesComponent, {
			disableClose: true,
			width: '650px',
			data,
		});
		dialogRef.componentInstance.updated.pipe(takeUntil(this.destroy$)).subscribe((_) => {
			this.getNotes();
		});
	}

	public pointerMove(event: PointerEvent): void {
		if (this.popup && this.popup.nativeElement) {
			const bounds = this.popup.nativeElement.getBoundingClientRect();
			this.popup.nativeElement.style.left = `${event.clientX - bounds.width}px`;
			this.popup.nativeElement.style.top = `${event.clientY + 24}px`;
		}
	}
}
